import { render, staticRenderFns } from "./ProstateSpecimen.vue?vue&type=template&id=3fa51342&scoped=true&"
import script from "./ProstateSpecimen.vue?vue&type=script&lang=js&"
export * from "./ProstateSpecimen.vue?vue&type=script&lang=js&"
import style0 from "./ProstateSpecimen.vue?vue&type=style&index=0&id=3fa51342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa51342",
  null
  
)

export default component.exports